module.exports = __webpack_public_path__ + "img/logo.ae71e782.png";